import Geolocation from '../geolocation.js';

export default {
    data() {
        return {
            isGameOpening: false,
        };
    },
    methods: {
        async openCasinoGame(gameId) {
            if (!this.isGameOpening) {

                try {
                    await Geolocation.saveGeolocationData('game open: ' + gameId);
                } catch (err) {}

                this.isGameOpening = true;
                window.location.replace(this.route('games.play', {
                    gameId: gameId,
                    languageCode: this.$i18n.locale
                }).url());

                setTimeout(() => {
                    this.isGameOpening = false;
                }, 5000);
            }
        },
        async openTerminalGame(gameId) {
            if (!this.isGameOpening) {

                try {
                    await Geolocation.saveGeolocationData('game open: ' + gameId);
                } catch (err) {}

                this.isGameOpening = true;
                window.location.replace(this.route('terminal.play', {
                    gameId: gameId
                }).url() + '?volume=' + encodeURIComponent(this.gameVolume / 100));

                setTimeout(() => {
                    this.isGameOpening = false;
                }, 5000);
            }
        }
    },
};
